import { crmTaskInputDtoSchema, hasRichTextContent } from '../../server/dto/crm-task-input-dto.ts';
import { richTextSchema } from '../../server/types/common-types.ts';

/**
 * The task input schema with the empty-description message the user should read. The DTO
 * rejects the same input, but its message is the API's, in English — and a form that
 * doesn't catch it first fails on submit, taking the whole log interaction down with it.
 */
export function createTaskFormSchema(descriptionRequiredMessage: string) {
    return crmTaskInputDtoSchema.extend({
        description: richTextSchema.refine(hasRichTextContent, {
            message: descriptionRequiredMessage,
        }),
    });
}
